export default __webpack_public_path__ + "static/media/co-worker.a35041f9.svg";